export default __webpack_public_path__ + "static/media/call.c4385a91.svg";